import React from 'react';
import { ConversationMessage } from '../interfaces/Derivation';
import { useFullChatMessages } from '../hooks/useFullChatMessages';
import { ChatMessageItem } from './ChatMessageItem';

interface FullChatViewProps {
  chatData?: string;
  conversation?: ConversationMessage[];
}

export const FullChatView: React.FC<FullChatViewProps> = ({
  chatData,
  conversation,
}) => {
  const messages = useFullChatMessages(chatData, conversation);

  return (
    <div className='flex flex-col space-y-4 w-full overflow-hidden'>
      {messages.length > 0 ? (
        messages.map((message, index) => (
          <ChatMessageItem key={`${index}-${message.role}`} message={message} />
        ))
      ) : (
        <div className='text-center text-gray-500 italic py-8'>
          No se encontró historial de chat.
        </div>
      )}
    </div>
  );
};
